/* Core & libraries */
import * as React from "react";
import { BrowserRouter } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import AppRoutes from "./appRoutes";

/* Styles */

const Router = () => {

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  )
}

export default Router;
